export default __webpack_public_path__ + "static/media/samir.65a144dc.jpg";